import { render, staticRenderFns } from "./simpleUser.vue?vue&type=template&id=35aaae9c&"
import script from "./simpleUser.vue?vue&type=script&lang=js&"
export * from "./simpleUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports